<template>
  <v-card flat>
    <v-card-text>
      <v-container v-if="pending" fill-height fluid>
        <v-row class="my-2" align="center" justify="center">
          <h2 class="basic--text">Please wait...</h2>
        </v-row>
        <v-row align="center" justify="center">
          <v-progress-circular
            :width="3"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-row>
      </v-container>

      <v-container v-else fill-height fluid>
        <v-row class="my-2" align="center" justify="center">
          <h1 :class="textColor">{{ responseMessage }}</h1>
        </v-row>
        <v-row class="pb-2" align="center" justify="center">
          <v-img
            v-if="filename != ''"
            :src="require(`@/assets/${filename}`)"
            max-width="300"
          >
          </v-img>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions v-if="!pending" class="justify-center">
      <v-btn-toggle>
        <v-btn outlined color="basic" @click="close">Close</v-btn>
        <v-btn
          v-if="showCheckBtn"
          outlined
          color="basic"
          @click="showProductInfo"
          >Check product <v-icon right>mdi-eye</v-icon></v-btn
        >
      </v-btn-toggle>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: "StatusInfo",
  props: {
    responseMessage: String,
    filename: String,
    pending: Boolean,
    textColor: String,
    showCheckBtn: Boolean,
  },
  methods: {
    close() {
      this.$emit("close");
    },
    showProductInfo() {
      this.$emit("showProductInfo");
    },
  },
};
</script>